import { GameScore } from './GameScore';

export default GameScore;
